import React from "react";

import css from "./ToggleButtons.module.css";

import cn from "classnames";

type Props<T> = {
    options: {
        label: string;
        value: T;
    }[];
    onChange: (value: T) => void;
    value: T;
};

export const ToggleButtons = <T extends string>({ options, onChange, value }: Props<T>) => {
    return (
        <div className={css.main}>
            {options.map((option) => (
                <button
                    key={option.value}
                    className={cn(css.button, {
                        [css.selected]: option.value === value,
                    })}
                    onClick={() => onChange(option.value)}
                >
                    {option.label}
                </button>
            ))}
        </div>
    );
};
